import { cardsItems } from '@/mocks/homeData';

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-[1200px] mx-auto">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between mb-10 md:mb-14 gap-3">
          <div>
            <span className="inline-block px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-medium mb-3">
              编辑精选
            </span>
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground-950">
              精选推荐
            </h2>
            <p className="mt-2 text-sm md:text-base text-foreground-600">
              编辑团队每日手工精选的优质内容，篇篇值得细读
            </p>
          </div>
          <a
            href="#updates"
            className="text-sm text-primary-600 hover:text-primary-700 font-medium flex items-center gap-1 whitespace-nowrap cursor-pointer"
          >
            查看全部更新 <i className="ri-arrow-right-line"></i>
          </a>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {cardsItems.slice(0, 3).map((card, index) => (
            <div
              key={index}
              className="bg-background-50 rounded-xl overflow-hidden group cursor-pointer"
            >
              <div className="aspect-[3/2] overflow-hidden">
                <img
                  src={card.image}
                  alt={card.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-5">
                <div className="flex items-center gap-3 mb-3 flex-wrap">
                  <span className="px-2.5 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs font-medium whitespace-nowrap">
                    {card.tag}
                  </span>
                  <span className="text-xs text-foreground-500 whitespace-nowrap">{card.time}</span>
                </div>
                <h3 className="text-base md:text-lg font-heading font-semibold text-foreground-900 mb-2 line-clamp-2 group-hover:text-primary-600 transition-colors">
                  {card.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed line-clamp-3">
                  {card.summary}
                </p>
              </div>
            </div>
          ))}
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 md:gap-6 mt-5 md:mt-6">
          {cardsItems.slice(3, 5).map((card, index) => (
            <div
              key={index + 3}
              className="bg-background-50 rounded-xl overflow-hidden group cursor-pointer flex flex-col sm:flex-row"
            >
              <div className="sm:w-2/5 aspect-[3/2] sm:aspect-auto overflow-hidden flex-shrink-0">
                <img
                  src={card.image}
                  alt={card.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-5 flex flex-col justify-center">
                <div className="flex items-center gap-3 mb-2 flex-wrap">
                  <span className="px-2 py-0.5 rounded-full bg-secondary-100 text-secondary-700 text-xs font-medium whitespace-nowrap">
                    {card.tag}
                  </span>
                  <span className="text-xs text-foreground-500 whitespace-nowrap">{card.time}</span>
                </div>
                <h3 className="text-sm md:text-base font-heading font-semibold text-foreground-900 mb-1 line-clamp-2 group-hover:text-primary-600 transition-colors">
                  {card.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-600 leading-relaxed line-clamp-2">
                  {card.summary}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}